import {createSlice} from '@reduxjs/toolkit'

export const campaignActionSlice = createSlice({
  name: 'campaignAction',
  initialState: {
    actionName: '',
    name: ''
  },
  reducers: {
    setCampaignAction: (state, action) => {
      state.actionName = action.payload.actionName
      state.name = action.payload.name
    }
  }
})

export const {setCampaignAction} = campaignActionSlice.actions

export default campaignActionSlice.reducer
